"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactBlocks = [{
  label: "Write to Us",
  value: "asahisearch@gmail.com"
}];
const genreOptions = ["Website Design", "Search Engine Optimization", "Local SEO & Google Maps", "General Consultation"];
export default function ContactUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}
function InvitationForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="py-8">
        <p className="font-default uppercase text-xs tracking-[0.2em] mb-6" style={{
        color: "var(--primary)"
      }}>
          — MESSAGE SENT
        </p>
        <p className="font-default text-foreground text-2xl leading-snug mb-8">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="font-default uppercase text-xs tracking-[0.2em] h-12 px-6 bg-transparent border-border text-foreground hover:bg-accent">
          Send Another Message
        </Button>
      </div>;
  }
  const minimalFieldClass = "bg-transparent border-0 border-b border-border rounded-none px-0 py-3 h-auto text-foreground font-default text-base placeholder:text-muted-foreground focus-visible:ring-0 focus-visible:border-b-2 focus-visible:border-[var(--primary)] shadow-none transition-colors";
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <FormField control={control} name="full_name" render={({
      field
    }) => <FormItem className="gap-2">
            <FormLabel className="font-default uppercase text-[11px] tracking-[0.2em]" style={{
        color: "var(--primary)"
      }}>
              Full Name
            </FormLabel>
            <FormControl>
              <Input placeholder="John Smith" className={minimalFieldClass} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" render={({
      field
    }) => <FormItem className="gap-2">
            <FormLabel className="font-default uppercase text-[11px] tracking-[0.2em]" style={{
        color: "var(--primary)"
      }}>
              Email Address
            </FormLabel>
            <FormControl>
              <Input type="email" placeholder="john@business.com" className={minimalFieldClass} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem className="gap-2">
            <FormLabel className="font-default uppercase text-[11px] tracking-[0.2em]" style={{
        color: "var(--primary)"
      }}>
              Phone Number (Optional)
            </FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+1 (555) 000-0000" className={minimalFieldClass} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="preferred_genre" render={({
      field
    }) => <FormItem className="gap-2">
            <FormLabel className="font-default uppercase text-[11px] tracking-[0.2em]" style={{
        color: "var(--primary)"
      }}>
              Service Interest
            </FormLabel>
            <FormControl>
              <Select onValueChange={field.onChange} value={field.value}>
                <SelectTrigger className="bg-transparent border-0 border-b border-border px-0 py-3 h-auto w-full text-foreground font-default text-base focus-visible:ring-0 focus-visible:border-b-2 focus-visible:border-[var(--primary)] data-[placeholder]:text-muted-foreground">
                  <SelectValue placeholder="Select a service" />
                </SelectTrigger>
                <SelectContent className="bg-popover border-border">
                  {genreOptions.map((genre, i) => <SelectItem key={genre} data-index={i} value={genre} className="font-default">
                      {genre}
                    </SelectItem>)}
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" render={({
      field
    }) => <FormItem className="gap-2">
            <FormLabel className="font-default uppercase text-[11px] tracking-[0.2em]" style={{
        color: "var(--primary)"
      }}>
              Your Message
            </FormLabel>
            <FormControl>
              <Textarea rows={6} placeholder="Tell us about your project..." className="bg-transparent border-0 border-b border-border px-0 py-3 text-foreground font-default text-base placeholder:text-muted-foreground focus-visible:ring-0 focus-visible:border-b-2 focus-visible:border-[var(--primary)] resize-none transition-colors" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 border" style={{
      backgroundColor: "hsl(0 84% 60% / 0.1)",
      borderColor: "var(--destructive)"
    }}>
          <p className="font-default uppercase text-xs tracking-wider text-destructive">
            {submitError}
          </p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-16 bg-primary text-primary-foreground hover:bg-primary/90 font-default uppercase text-sm tracking-[0.2em] rounded-lg shadow-lg" style={{
      boxShadow: "0 10px 20px hsl(200 70% 55% / 0.3)"
    }}>
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-4" />
            Sending...
          </> : <>
            <ArrowRight className="mr-2 size-4" />
            Submit Request
          </>}
      </Button>
    </Form>;
}